import React from 'react'
import Location from "./location.svg"
function LocationIcon() {
    return <img src={Location} alt="Location Icon" />;
}

export default LocationIcon